export default "__VITE_ASSET__cb6ece7b__"